import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IContact } from '@leedpulse-monorepo/interfaces';

async function toggleAIPauseOfContact(
  contact: IContact,
  auth: Authentication
): Promise<void> {
  try {
    await HttpClient.put(
      '/contact',
      {
        id: contact.id,
        messages_settings: {
          ia_pause: !contact.messages_settings.ia_pause,
        },
        updated: new Date().getTime(),
      },
      auth.token,
      {
        'x-api-key': contact.id_api_key,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new ToggleAIPauseOfContactFailure();
  }
}

export class ToggleAIPauseOfContactFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default toggleAIPauseOfContact;
